// カテゴリ表示順を統一するヘルパ
// 全て / 履歴 / 季節 はラッパ側で先頭に置く想定
// その後のカテゴリは: 野菜 → 果物 → カット野菜 → 加工品 → その他（名前順）
const PREFERRED_ORDER = ["野菜", "果物", "カット野菜", "加工品"];

export const getCategorySortKey = (name) => {
  if (!name) return [99, ""];
  const idx = PREFERRED_ORDER.indexOf(name);
  if (idx >= 0) return [idx, ""];
  return [PREFERRED_ORDER.length, name];
};

export const sortCategories = (categories) => {
  return [...(categories || [])].sort((a, b) => {
    const [ka, na] = getCategorySortKey(a?.name);
    const [kb, nb] = getCategorySortKey(b?.name);
    if (ka !== kb) return ka - kb;
    return (na || "").localeCompare(nb || "", "ja");
  });
};
